/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-logs-graph';
const prefix = `${moduleName}.${componentName}`;

export const significantLabel = `${prefix}.significantLabel`;
export const nonSignificantLabel = `${prefix}.nonSignificantLabel`;
export const missingLabel = `${prefix}.missingLabel`;
export const missingDescription = `${prefix}.missingDescription`;

export const ENGLISH = {
    [significantLabel]: 'Significant',
    [nonSignificantLabel]: 'Non-significant',
    [missingLabel]: 'Missing Logs',
    [missingDescription]: 'This could be due to purging or rate limiting logs.',
};
